// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  font-family: system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif;
}

.agent-container {
  height: calc(100% - 24px);
  display: flex;
  flex-direction: column;
}

.content {
  flex: 1 1 0%;
  overflow: hidden;
}

.header-bar {
  padding: 0.75rem;
  display: flex;
  z-index: 10;
}
.header-bar .section {
  display: flex;
  align-items: center;
}
.header-bar .section.left {
  overflow: hidden;
}

.agent-container {
  height: calc(100% - 24px);
  display: flex;
  flex-direction: column;
}

.table-container {
  flex: 1 1 auto;
  overflow-y: auto; /* Enables vertical scrolling */
  overflow-x: hidden; /* Prevents horizontal scrolling */
}

.hidden {
  display: none;
}

.clickable-row {
  cursor: pointer;
}
.clickable-row:hover {
  background-color: rgba(0, 0, 0, 0.1); /* Adjust based on theme */
}

.mat-mdc-form-field-bottom-align {
  height: 0;
  margin: 0;
  padding: 0;
}

:host ::ng-deep .mat-mdc-form-field-bottom-align {
  display: none !important;
}

.sub-titlebar {
  font-size: 14px;
  padding: 10px 1rem 1.25rem;
  align-items: center;
  gap: 12px;
  display: flex;
  z-index: 10000;
}
.sub-titlebar input {
  z-index: 5;
}

.ticker {
  line-height: 1rem;
  height: 1rem;
}

.description {
  font-size: 10px;
  line-height: 10px;
  opacity: 0.6;
}

.user-input {
  width: 100%;
}
.user-input .prompt-box {
  margin: 0 auto;
  display: flex;
  flex-grow: 1;
  padding: 0 0.75rem;
}
@media (min-width: 1200px) {
  .user-input .prompt-box {
    max-width: 48rem;
    padding: 0 1.25rem;
  }
}
@media (min-width: 992px) {
  .user-input .prompt-box {
    max-width: 40rem;
    padding: 0 0.25rem;
  }
}
@media (min-width: 768px) {
  .user-input .prompt-box {
    max-width: 48rem;
    padding: 0 1rem;
  }
}
.user-input .mistake-warning {
  font-size: 0.75rem;
  line-height: 1rem;
  text-align: center;
  padding: 0.5rem 0;
}

mat-form-field.input {
  width: 100%;
}

.chat-edit-button {
  color: #777;
}

.model-selector {
  width: 320px;
}

.model-listing {
  display: grid;
  grid-template-columns: min-content 1fr;
  grid-template-rows: 1fr 1rem;
  gap: 0px 12px;
  grid-template-areas: "icon name" "icon desc";
}
.model-listing .model-icon {
  margin: 0;
  grid-area: icon;
  width: 32px;
  height: 32px;
  align-self: center;
}
.model-listing .model-name {
  grid-area: name;
}
.model-listing .model-description {
  grid-area: desc;
  font-size: 0.75rem;
  line-height: 1rem;
}`, "",{"version":3,"sources":["webpack://./src/app/components/strategy-grid/agent-widget/agent-widget.component.scss","webpack://./src/styles/_breakpoints.scss"],"names":[],"mappings":"AAEA;EACE,mJACE;AAFJ;;AAeA;EACE,yBAAA;EACA,aAAA;EACA,sBAAA;AAZF;;AAeA;EACE,YAAA;EACA,gBAAA;AAZF;;AAeA;EACE,gBAAA;EACA,aAAA;EACA,WAAA;AAZF;AAcE;EACE,aAAA;EACA,mBAAA;AAZJ;AAcI;EACE,gBAAA;AAZN;;AAiBA;EACE,yBAAA;EACA,aAAA;EACA,sBAAA;AAdF;;AAiBA;EACE,cAAA;EACA,gBAAA,EAAA,+BAAA;EACA,kBAAA,EAAA,kCAAA;AAdF;;AAiBA;EACE,aAAA;AAdF;;AAiBA;EACE,eAAA;AAdF;AAeE;EACE,oCAAA,EAAA,0BAAA;AAbJ;;AAiBA;EACE,SAAA;EACA,SAAA;EACA,UAAA;AAdF;;AAkBE;EACE,wBAAA;AAfJ;;AAmBA;EACE,eAAA;EAEA,0BAAA;EACA,mBAAA;EACA,SAAA;EACA,aAAA;EACA,cAAA;AAjBF;AAkBE;EACE,UAAA;AAhBJ;;AAoBA;EACE,iBAAA;EACA,YAAA;AAjBF;;AAoBA;EACE,eAAA;EACA,iBAAA;EACA,YAAA;AAjBF;;AAoBA;EACE,WAAA;AAjBF;AAmBE;EACE,cAAA;EACA,aAAA;EACA,YAAA;EACA,kBAAA;AAjBJ;AChFI;ED6FF;IAOI,gBAAA;IACA,kBAAA;EAhBJ;AACF;ACtFI;ED6FF;IAYI,gBAAA;IACA,kBAAA;EAfJ;AACF;AC5FI;ED6FF;IAiBI,gBAAA;IACA,eAAA;EAdJ;AACF;AAiBE;EACE,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,iBAAA;AAfJ;;AAmBA;EACE,WAAA;AAhBF;;AAmBA;EACE,WAAA;AAhBF;;AAmBA;EAGE,YAAA;AAlBF;;AA6BA;EACE,aAAA;EACA,sCAAA;EACA,4BAAA;EACA,aAAA;EACA,4CACE;AA3BJ;AA8BE;EACE,SAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;AA5BJ;AA+BE;EACE,eAAA;AA7BJ;AAgCE;EACE,eAAA;EACA,kBAAA;EACA,iBAAA;AA9BJ","sourcesContent":["@import '../../../../styles/breakpoints';\n\n:host {\n  font-family:\n    system-ui,\n    -apple-system,\n    BlinkMacSystemFont,\n    'Segoe UI',\n    Roboto,\n    Oxygen,\n    Ubuntu,\n    Cantarell,\n    'Open Sans',\n    'Helvetica Neue',\n    sans-serif;\n}\n\n.agent-container {\n  height: calc(100% - 24px);\n  display: flex;\n  flex-direction: column;\n}\n\n.content {\n  flex: 1 1 0%;\n  overflow: hidden;\n}\n\n.header-bar {\n  padding: 0.75rem;\n  display: flex;\n  z-index: 10;\n\n  .section {\n    display: flex;\n    align-items: center;\n\n    &.left {\n      overflow: hidden;\n    }\n  }\n}\n\n.agent-container {\n  height: calc(100% - 24px);\n  display: flex;\n  flex-direction: column;\n}\n\n.table-container {\n  flex: 1 1 auto;\n  overflow-y: auto; /* Enables vertical scrolling */\n  overflow-x: hidden; /* Prevents horizontal scrolling */\n}\n\n.hidden {\n  display: none;\n}\n\n.clickable-row {\n  cursor: pointer;\n  &:hover {\n    background-color: rgba(0, 0, 0, 0.1); /* Adjust based on theme */\n  }\n}\n\n.mat-mdc-form-field-bottom-align {\n  height: 0;\n  margin: 0;\n  padding: 0;\n}\n\n:host {\n  ::ng-deep .mat-mdc-form-field-bottom-align {\n    display: none !important;\n  }\n}\n\n.sub-titlebar {\n  font-size: 14px;\n\n  padding: 10px 1rem 1.25rem;\n  align-items: center;\n  gap: 12px;\n  display: flex;\n  z-index: 10000;\n  & input {\n    z-index: 5;\n  }\n}\n\n.ticker {\n  line-height: 1rem;\n  height: 1rem;\n}\n\n.description {\n  font-size: 10px;\n  line-height: 10px;\n  opacity: 0.6;\n}\n\n.user-input {\n  width: 100%;\n\n  .prompt-box {\n    margin: 0 auto;\n    display: flex;\n    flex-grow: 1;\n    padding: 0 0.75rem;\n\n    @include respond-to(xl) {\n      max-width: 48rem;\n      padding: 0 1.25rem;\n    }\n\n    @include respond-to(lg) {\n      max-width: 40rem;\n      padding: 0 0.25rem;\n    }\n\n    @include respond-to(md) {\n      max-width: 48rem;\n      padding: 0 1rem;\n    }\n  }\n\n  .mistake-warning {\n    font-size: 0.75rem;\n    line-height: 1rem;\n    text-align: center;\n    padding: 0.5rem 0;\n  }\n}\n\nmat-form-field.input {\n  width: 100%;\n}\n\n.chat-edit-button {\n  color: #777;\n}\n\n.model-selector {\n  // font-weight: 600;\n  // font-size: 1.125rem;\n  width: 320px;\n  // height: 2.5rem;\n  // line-height: 1.75rem;\n  // padding: 0.375rem 0.75rem;\n  // border-radius: 0.5rem;\n  // overflow: hidden;\n  // align-items: center;\n  // display: flex;\n  // white-space: nowrap;\n}\n\n.model-listing {\n  display: grid;\n  grid-template-columns: min-content 1fr;\n  grid-template-rows: 1fr 1rem;\n  gap: 0px 12px;\n  grid-template-areas:\n    'icon name'\n    'icon desc';\n\n  .model-icon {\n    margin: 0;\n    grid-area: icon;\n    width: 32px;\n    height: 32px;\n    align-self: center;\n  }\n\n  .model-name {\n    grid-area: name;\n  }\n\n  .model-description {\n    grid-area: desc;\n    font-size: 0.75rem;\n    line-height: 1rem;\n  }\n}\n","$breakpoints: (\n  'xs': 0px,\n  'sm': 576px,\n  'md': 768px,\n  'lg': 992px,\n  'xl': 1200px,\n  'xxl': 1400px,\n  'xxxl': 2100px\n) !default;\n\n@mixin respond-to($breakpoint) {\n  @if map-has-key($breakpoints, $breakpoint) {\n    @media (min-width: map-get($breakpoints, $breakpoint)) {\n      @content;\n    }\n  } @else {\n    @warn \"Unfortunately, no value could be retrieved from `#{$breakpoint}`. Available breakpoints are: #{map-keys($breakpoints)}.\";\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
